// src/sectors/pilates/settings/tabs/notifications/notificationsEmailUtils.js

export function getByPath(obj, path) {
  const keys = String(path || '')
    .split('.')
    .filter(Boolean);
  let v = obj;
  for (const k of keys) v = v?.[k];
  return v;
}

export function setByPathEnsure(obj, path, value) {
  const keys = String(path || '')
    .split('.')
    .filter(Boolean);
  if (!keys.length) return obj;

  let cur = obj;
  for (let i = 0; i < keys.length - 1; i += 1) {
    const k = keys[i];
    const nxt = cur[k];
    if (nxt == null || typeof nxt !== 'object' || Array.isArray(nxt)) cur[k] = {};
    cur = cur[k];
  }
  cur[keys[keys.length - 1]] = value;
  return obj;
}

// ✅ recipients helpers (EmailRecipientsSection bunu istiyor)
export function parseEmailsCsv(s) {
  const raw = String(s || '').trim();
  if (!raw) return [];
  return raw
    .split(/[,\n]/g)
    .map((x) => x.trim())
    .filter(Boolean);
}

export function emailsToCsv(list) {
  if (!Array.isArray(list) || list.length === 0) return '';
  return list.join(', ');
}

// Frontend default (backend ile aynı shape)
export function defaultEmailNotificationsEmail() {
  return {
    enabled: true,
    morning: {
      sendGeneralPlanToAllStaff: true,
      sendOwnerActivitySummary: true,
    },
    evening: {
      sendOwnerDoneList: true,
      sendOwnerMemberLogs: true,
      sendOwnerMissingAttendanceAlert: true,
      showMissingStaffList: false,
      sendTrainerMissingAttendanceAlert: false, // ✅ EKLE
    },
  };
}

// eksik alanları tamamla (backend'ten null/partial gelebilir)
export function normalizeEmailSettings(rawEmail) {
  const d = defaultEmailNotificationsEmail();
  const e = rawEmail && typeof rawEmail === 'object' ? rawEmail : {};

  const safeArray = (v) => (Array.isArray(v) ? v.filter(Boolean) : []);
  const safeBool = (v, def) => (typeof v === 'boolean' ? v : def);

  return {
    enabled: safeBool(e.enabled, d.enabled),
    morning: {
      sendGeneralPlanToAllStaff: safeBool(
        e?.morning?.sendGeneralPlanToAllStaff,
        d.morning.sendGeneralPlanToAllStaff
      ),
      sendOwnerActivitySummary: safeBool(
        e?.morning?.sendOwnerActivitySummary,
        d.morning.sendOwnerActivitySummary
      ),
    },
    evening: {
      sendOwnerDoneList: safeBool(e?.evening?.sendOwnerDoneList, d.evening.sendOwnerDoneList),
      sendOwnerMemberLogs: safeBool(e?.evening?.sendOwnerMemberLogs, d.evening.sendOwnerMemberLogs),
      sendOwnerMissingAttendanceAlert: safeBool(
        e?.evening?.sendOwnerMissingAttendanceAlert,
        d.evening.sendOwnerMissingAttendanceAlert
      ),
      showMissingStaffList: safeBool(
        e?.evening?.showMissingStaffList,
        d.evening.showMissingStaffList
      ),

      // ✅ EKLE (asıl kaybolan alan buydu)
      sendTrainerMissingAttendanceAlert: safeBool(
        e?.evening?.sendTrainerMissingAttendanceAlert,
        d.evening.sendTrainerMissingAttendanceAlert
      ),
    },
  };
}

// companySettingsApi.getMy() response -> email settings extract + normalize
export function extractEmailSettingsFromCompanySettings(me) {
  const sector = me?.sectorSettings || {};
  const notifications = sector?.notifications || {};
  const email = notifications?.email || null;
  return normalizeEmailSettings(email);
}

// Save için: sectorSettings içine email'i yazarak yeni payload üret
export function buildSectorSettingsWithEmail(prevSectorSettings, emailDraft) {
  const ss = prevSectorSettings && typeof prevSectorSettings === 'object' ? prevSectorSettings : {};
  const next = structuredClone(ss);

  if (
    !next.notifications ||
    typeof next.notifications !== 'object' ||
    Array.isArray(next.notifications)
  ) {
    next.notifications = {};
  }

  next.notifications.email = normalizeEmailSettings(emailDraft);
  return next;
}
